module.exports = __webpack_public_path__ + "static/img/1.e718746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R134A/1.jpg
// module id = aAVE
// module chunks = 1